'use strict';

import axios from 'axios';

const routes = {
  signUp: '/sign-up',
  signIn: '/sign-in',
  activateAccount: '/account-activation',
  reSendActivationEmail: '/account-activation/email',
  candidateProfile: '/profile', // note post and get will do different things here.
  searchForCandidates: '/search',
  autocompleteSkills: '/search/skill/',
  autocompleteIndustries: '/search/industry/',
  autocompleteUniversities: '/search/university/',
  chatList: '/chat/allchats',
  chatDetails: '/chat/chatdetail',
  unreadChatMessages: '/chat/unreadchats',
  sendResetPasswordEmail: '/reset-password/email',
  updateUserPassword: '/reset-password/',
  validatePasswordResetToken: '/reset-password/check'
};

function buildApiRequest (requestMethod, headers, url, data) {
  return axios({
    method: requestMethod,
    headers: headers,
    url: url,
    data: data
  });
}

/* SIGN UP // LOGIN // ACCOUNT */
export const signUpNewUser = (data, headers) => buildApiRequest('post', headers, routes.signUp, data);

export const signInUser = (data, headers) => buildApiRequest('post', headers, routes.signIn, data);

export const activateUser = (data, headers) => buildApiRequest('post', headers, routes.activateAccount, data);

export const reSendActivationEmail = (data, headers) => buildApiRequest('post', headers, routes.reSendActivationEmail, data);

export const sendResetPasswordEmail = (data, headers) => buildApiRequest('post', headers, routes.sendResetPasswordEmail, data);

export const validatePasswordResetToken = (data, headers) => buildApiRequest('post', headers, routes.validatePasswordResetToken, data);

export const updateUserPassword = (data, headers) => buildApiRequest('post', headers, routes.updateUserPassword, data);

/* CANDIDATE PROFILE */
export const editCandidateProfile = (data, headers) => buildApiRequest('post', headers, routes.candidateProfile, data);

export const getUserProfile = (headers) => buildApiRequest('get', headers, routes.candidateProfile);

/* CANDIDATE SEARCH */
export const searchForCandidates = (data, headers) => buildApiRequest('post', headers, routes.searchForCandidates, data);

/* CHAT */
export const getChatList = (data, headers) => buildApiRequest('post', headers, routes.chatList, data);

export const getChatDetails = (data, headers) => buildApiRequest('post', headers, routes.chatDetails, data);

export const getUnreadMessageCount = (data, headers) => buildApiRequest('post', headers, routes.unreadChatMessages, data);

/* UTILITIES -- AUTOCOMPLETE SEARCHES */
export const getSkills = (apiHeaders, skillQuery) => {
  return axios({
    method: 'get',
    url: `${routes.autocompleteSkills}${skillQuery}`,
    headers: apiHeaders
  });
};

export const getIndustries = (apiHeaders, industryQuery) => {
  return axios({
    method: 'get',
    url: `${routes.autocompleteIndustries}${industryQuery}`,
    headers: apiHeaders
  });
};

export const getUniversities = (apiHeaders, universityQuery) => {
  return axios({
    method: 'get',
    url: `${routes.autocompleteUniversities}${universityQuery}`,
    headers: apiHeaders
  });
};
